import {
    /** FETCH APPLICATION  */
    FETCH_CAREPROVIDERSV2_FULFILLED,
    FETCH_CAREPROVIDERSV2_REJECTED,
    FETCH_CAREPROVIDERSV2_PENDING,
    RESET_CAREPROVIDERSV2
} from "../../actions/v3/careProviders";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CAREPROVIDERSV2_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_CAREPROVIDERSV2_FULFILLED:
            return {
                ...state,
                careProvidersv2: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_CAREPROVIDERSV2_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_CAREPROVIDERSV2:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};